export const API_VERSION_PREFIX = '/api/v1';

export const apiRoutes = {
  system: {
    info: '/system/info',
    health: '/system/health',
  },
  auth: {
    me: '/auth/me',
    availability: '/auth/me/availability',
    login: '/auth/login',
    verifyOtp: '/auth/verify-otp',
    resendOtp: '/auth/resend-otp',
    refresh: '/auth/refresh',
    logout: '/auth/logout',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
  },
  bootstrap: '/bootstrap',
} as const;

export function versionedApiRoute(route: string): string {
  return `${API_VERSION_PREFIX}${route}`;
}

export function catalogueApiRoute(path: string): string {
  return path.startsWith('/') ? path : `/${path}`;
}
